// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.renewal.LeaseRenewalPreferenceWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  LeaseRenewalPreferenceWebApiHandler_createPreference,
  LeaseRenewalPreferenceWebApiHandler_createWithPreferences,
  LeaseRenewalPreferenceWebApiHandler_sendRenewalProposal,
} from '@zg-rentals/ts-leasing-client';

import type {
  CreateLeaseExtensionPreferenceRequestDto,
  CreateLeaseExtensionPreferenceResponseDto,
  CreateLeaseRenewalResponseDto,
  CreateLeaseRenewalWithPreferencesRequestDto,
  SendRenewalProposalRequestDto,
} from '@zg-rentals/ts-leasing-client';

export interface LeaseRenewalPreferenceWebApiHandler_createPreference_Args {
  postData: CreateLeaseExtensionPreferenceRequestDto;
}

export type LeaseRenewalPreferenceWebApiHandler_createPreference_Options = UseMutationOptions<
  CreateLeaseExtensionPreferenceResponseDto,
  unknown,
  LeaseRenewalPreferenceWebApiHandler_createPreference_Args
>;

/**
 * create lease extension preference
 */
export const useLeaseRenewalPreferenceWebApiHandler_createPreference = ({
  httpClient,
  ...options
}: Omit<LeaseRenewalPreferenceWebApiHandler_createPreference_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: LeaseRenewalPreferenceWebApiHandler_createPreference_Args) =>
      LeaseRenewalPreferenceWebApiHandler_createPreference(args.postData, httpClient),
  });
};

export interface LeaseRenewalPreferenceWebApiHandler_createWithPreferences_Args {
  postData: CreateLeaseRenewalWithPreferencesRequestDto;
}

export type LeaseRenewalPreferenceWebApiHandler_createWithPreferences_Options = UseMutationOptions<
  CreateLeaseRenewalResponseDto,
  unknown,
  LeaseRenewalPreferenceWebApiHandler_createWithPreferences_Args
>;

/**
 * create new lease renewal with preferences
 */
export const useLeaseRenewalPreferenceWebApiHandler_createWithPreferences = ({
  httpClient,
  ...options
}: Omit<LeaseRenewalPreferenceWebApiHandler_createWithPreferences_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: LeaseRenewalPreferenceWebApiHandler_createWithPreferences_Args) =>
      LeaseRenewalPreferenceWebApiHandler_createWithPreferences(args.postData, httpClient),
  });
};

export interface LeaseRenewalPreferenceWebApiHandler_sendRenewalProposal_Args {
  postData: SendRenewalProposalRequestDto;
}

export type LeaseRenewalPreferenceWebApiHandler_sendRenewalProposal_Options = UseMutationOptions<
  void,
  unknown,
  LeaseRenewalPreferenceWebApiHandler_sendRenewalProposal_Args
>;

/**
 * send renewal proposal
 */
export const useLeaseRenewalPreferenceWebApiHandler_sendRenewalProposal = ({
  httpClient,
  ...options
}: Omit<LeaseRenewalPreferenceWebApiHandler_sendRenewalProposal_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: LeaseRenewalPreferenceWebApiHandler_sendRenewalProposal_Args) =>
      LeaseRenewalPreferenceWebApiHandler_sendRenewalProposal(args.postData, httpClient),
  });
};
